
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 7 8"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 7.563V.436C0 .04.584-.112.908.088l5.806 3.545c.322.202.403.531.081.733L.867 7.911C.545 8.113 0 7.958 0 7.563z"}})])
          )
        }
      }
    